const LoaderSimChart = () => {
    return (
        <div className="geo_overview_res_cont_chart_loader_main">
            <div className="geo_overview_res_cont_chart_loader_header">
                <div className="geo_overview_res_cont_chart_loader_header_btn fade-in"></div>
                <div className="geo_overview_res_cont_chart_loader_header_btn fade-in"></div>
                <div className="geo_overview_res_cont_chart_loader_header_btn fade-in"></div>
                <div className="geo_overview_res_cont_chart_loader_header_btn fade-in"></div>
            </div>
            <div className="geo_overview_res_cont_chart_loader">
                <div className="geo_overview_res_cont_chart_loader_row">
                    <div className="axis_item_loader fade-in"></div>
                </div>
                <div className="geo_overview_res_cont_chart_loader_row">
                    <div className="axis_item_loader fade-in"></div>
                </div>
                <div className="geo_overview_res_cont_chart_loader_row">
                    <div className="axis_item_loader fade-in"></div>
                </div>
                <div className="geo_overview_res_cont_chart_loader_row">
                    <div className="axis_item_loader fade-in"></div>
                </div>
                <div className="geo_overview_res_cont_chart_loader_row">
                    <div className="axis_item_loader_end fade-in" />
                    <div className="axis_item_loader_end fade-in" />
                    <div className="axis_item_loader_end fade-in" />
                </div>
            </div>
        </div>
    )
}

export default LoaderSimChart